/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Api_Errors_Upload_FailedInputs */

const nl_file_upload_api_errors_upload_failed = /** @type {(inputs: File_Upload_Api_Errors_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het uploaden van het bestand is mislukt.`)
};

/**

* @param {File_Upload_Api_Errors_Upload_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const file_upload_api_errors_upload_failed = /** @type {((inputs?: File_Upload_Api_Errors_Upload_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Api_Errors_Upload_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_file_upload_api_errors_upload_failed(inputs)
});
export { file_upload_api_errors_upload_failed as "file_upload.api_errors.upload_failed" }